import { Befehl, generateBefehlFrontendId } from '@repo/ui'
import { BefehlDto } from '@/apis/dtos/befehl-dto'

/**
 * Converts a BefehlDto to a Befehl model.
 *
 * @param dto The BefehlDto to convert
 * @param parentId The ID of the parent (Befehlsnachricht, Muster, or Auftrag)
 * @param index The position of this Befehl in the parent's befehle array
 * @returns A Promise that resolves to a Befehl model
 */
export async function convertBefehlDtoToModel(
  dto: BefehlDto,
  parentId: string,
  index: number
): Promise<Befehl> {
  return {
    frontendId: await generateBefehlFrontendId(dto, parentId, index),
    kennung: dto.kennung,
    auftraege: dto.auftraege
  }
}

/**
 * Converts a Befehl model to a BefehlDto.
 *
 * @param model The Befehl model to convert
 * @returns A Promise that resolves to a BefehlDto
 */
export async function convertBefehlModelToDto(
  model: Befehl
): Promise<BefehlDto> {
  return {
    kennung: model.kennung,
    auftraege: model.auftraege
  }
}
